/**
 * <pj-bundle-remove> — removes every cart line of an initials-builder set at once.
 *
 * data-keys: comma-separated line item keys sharing one _bundle_id property.
 * Posts a single /cart/update.js call setting all keys to 0, then re-renders the
 * cart sections through the enclosing cart-items / cart-drawer-items element so
 * the drawer and cart page update exactly like a native single-line removal.
 */
if (!customElements.get('pj-bundle-remove')) {
  customElements.define(
    'pj-bundle-remove',
    class PjBundleRemove extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('button');
        if (btn) {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.removeBundle();
          });
        }
      }

      async removeBundle() {
        const keys = (this.dataset.keys || '').split(',').filter(Boolean);
        if (keys.length === 0) return;

        const container =
          this.closest('cart-drawer-items') || this.closest('cart-items');
        if (!container || typeof container.getSectionsToRender !== 'function') {
          // Fallback: no cart machinery available — hard reload after update.
          await this.postUpdates(keys, []);
          window.location.reload();
          return;
        }

        const row = this.closest('.cart-item');
        if (row) row.classList.add('pj-bundle--removing');

        try {
          const sections = container.getSectionsToRender().map((s) => s.section);
          const parsedState = await this.postUpdates(keys, sections);

          if (parsedState.errors) throw new Error(parsedState.errors);

          const isEmpty = parsedState.item_count === 0;
          container.classList.toggle('is-empty', isEmpty);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', isEmpty);
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

          container.getSectionsToRender().forEach((section) => {
            const sectionEl = document.getElementById(section.id);
            if (!sectionEl || !parsedState.sections[section.section]) return;
            const target = sectionEl.querySelector(section.selector) || sectionEl;
            target.innerHTML = container.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pj-bundle-remove',
              cartData: parsedState,
            });
          }
          if (typeof container.updateProgressBar === 'function') {
            container.updateProgressBar();
          }
          if (typeof container.onCartUpdate === 'function') {
            container.onCartUpdate();
          }
        } catch (err) {
          console.error('[Bundle remove] failed', err);
          if (row) row.classList.remove('pj-bundle--removing');
          const errors =
            document.getElementById('cart-errors') ||
            document.getElementById('CartDrawer-CartErrors');
          if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        }
      }

      async postUpdates(keys, sections) {
        const updates = {};
        keys.forEach((key) => (updates[key] = 0));

        const body = {
          updates,
          sections_url: window.location.pathname,
        };
        if (sections.length) body.sections = sections;

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig()
            : {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
              };

        const response = await fetch(
          `${window.routes?.cart_update_url || '/cart/update.js'}`,
          { ...config, body: JSON.stringify(body) }
        );
        return response.json();
      }
    }
  );
}
